<template>
    <v-card class="services elevation-6" shaped>
        <v-card-title>
            <h4 style="word-break: break-word;">
                Annual Check-up (ACU)
            </h4>
        </v-card-title>
        <v-divider />
        <v-container>
            <h5 style="word-break: break-word;">
                An Annual Check-up (ACU) is a suite of services recommended to
                evaluate your state-of-health.
            </h5>
            <v-btn
                small
                class="teal accent-4 white--text my-4"
                @click="showAnnualCheckup = !showAnnualCheckup"
            >
                Read more
            </v-btn>
        </v-container>

        <!-- DIALOG BOX -->
        <AnnualCheckup
            :show-annual-checkup="showAnnualCheckup"
            @showDialog="showAnnualCheckupDialog"
        />
    </v-card>
</template>

<script>
import AnnualCheckup from '../DialogBoxes/AnnualCheckup.vue'
export default {
    components: { AnnualCheckup },
    data: () => ({ showAnnualCheckup: false }),
    methods: {
        showAnnualCheckupDialog(showAnnualCheckup) {
            this.showAnnualCheckup = showAnnualCheckup
        }
    }
}
</script>

<style scoped>
.services {
  text-align: justify;
  width: 250px;
}
.services h5 {
  font-weight: normal;
}
@media (max-width: 599px) {
  .services {
    margin-top: 20px;
    width: 95%;
  }
}
@media (min-width: 599px) and (max-width: 1904px) {
  .services {
    margin-top: 15px;
    width: 45%;
  }
}
</style>
